import { Component } from "react";
import PropTypes from "prop-types";

export default class AgnosticLoader extends Component {
  static propTypes = {
    fetch: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    children: PropTypes.element.isRequired
  };

  state = {
    loading: true,
    id: null
  };

  componentWillMount() {
    this.setState({ loading: true });
    const { id, fetch } = this.props;
    fetch(id).then(() => this.setState({ loading: false }));
  }

  render() {
    return this.props.children({
      ...this.state
    });
  }
}



// WEBPACK FOOTER //
// ./app/modules/shared/containers/AgnosticLoader/AgnosticLoader.jsx